export enum InitType {
    UPLOAD = 'upload',
    MANUAL = 'manual',
    PUBLICK_LINK = 'public_link',
}
